import { Injectable } from '@angular/core';
import { Category } from '../models/index';
import { MOCK_CATEGORIES } from '../data/mock-data';
import { getSupabase, isSupabaseConfigured } from '../firebase';
import { SupabaseClient } from '@supabase/supabase-js';

const CATEGORY_TABLE = 'categories';

@Injectable({ providedIn: 'root' })
export class CategoryService {
  private supabase: SupabaseClient | null = getSupabase();

  async getCategories(): Promise<Category[]> {
    if (!isSupabaseConfigured() || !this.supabase) {
      return Promise.resolve(MOCK_CATEGORIES);
    }
    const { data, error } = await this.supabase.from(CATEGORY_TABLE).select('*');
    if (error) throw error;
    return (data || []).map(c => ({
        ...c,
        storeId: c.store_id,
        createdAt: c.created_at
    })) as Category[];
  }
  
  async addCategory(name: string): Promise<Category> {
    if (!isSupabaseConfigured() || !this.supabase) {
      const newCategory: Category = { name, id: `mock-${Date.now()}`, storeId: 'mock-store', createdAt: new Date().toISOString() };
      return Promise.resolve(newCategory);
    }
    const { data, error } = await this.supabase.from(CATEGORY_TABLE).insert({ name }).select().single();
    if (error) throw error;
    return data as Category;
  }

  async updateCategory(id: string, name: string): Promise<Category> {
    if (!isSupabaseConfigured() || !this.supabase) {
        const updatedCategory: Category = { id, name, storeId: 'mock-store', createdAt: new Date().toISOString() };
        return Promise.resolve(updatedCategory);
    }
    const { data, error } = await this.supabase.from(CATEGORY_TABLE).update({ name }).eq('id', id).select().single();
    if (error) throw error;
    return data as Category;
  }

  async deleteCategory(id: string): Promise<void> {
    if (!isSupabaseConfigured() || !this.supabase) {
        return Promise.resolve();
    }
    const { error } = await this.supabase.from(CATEGORY_TABLE).delete().eq('id', id);
    if (error) throw error;
  }
}
